module.exports = __webpack_public_path__ + "static/media/guided-challenges.442e9c69.svg";